export type TabKey = 'market' | 'orders' | 'profile';

export interface TabDefinition {
  key: TabKey;
  label: string;
}

export const TABS: TabDefinition[] = [
  { key: 'market', label: 'Market' },
  { key: 'orders', label: 'Orders' },
  { key: 'profile', label: 'Profile' },
];
